import React from 'react';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';
import AddAttendanceAdjustment from './AddAttendanceAdjustment';
import { useParams } from 'react-router-dom';

const AttendanceAdjustment = () => {
  const { personId } = useParams();

  var BreadcrumbList = [
    {
      name: 'Home',
      link: ':moduleHome',
    },
    {
      name: 'Employees',
      link: '/HR/Employees',
    },
    {
      name: 'الإستئذانات',
      link: null,
    },
  ];

  return (
    <>
      <Breadcrumb
        BreadcrumbList={BreadcrumbList}
        PageName="الإستئذانات"
        // subtitle={i18n.language === 'ar' ? data.name2 : data.name}
      />

      <Card>
        <CardBody>{personId && <AddAttendanceAdjustment personId={personId} />}</CardBody>
      </Card>
    </>
  );
};

export default AttendanceAdjustment;
